import React from 'react';
import { Provider } from 'react-redux';
import { connect } from 'react-redux';
import { authentication } from '../../app-database';
import { conectarFirebase } from '../../app-persistance';
import AutorizacionModificacionMovilModal from '../../miPerfil/AutorizacionModificacionMovilModal.cmpt';
import ModalCambiarContrasena from '../../miPerfil/modalCodigoVerificacion.cmpt.js';
import { cargarPreguntas, generarOtp } from '../../miPerfil/datos.act';

const mapState = (state) => {
    return {
        paso: state.miPerfil.pasoCodigo,
        muestraCodigoV:state.miPerfil.muestraCodigoV,
        objeto: state.miPerfil.objTemporal
    };
}

const mapDispatch = (dispatch) => {
    return {
         cargarPreguntas : () =>{ 
             dispatch(cargarPreguntas()); 
         },
         generarOtp: (num) => {
			dispatch(generarOtp(num));
		},
         setDatosOtp: (num, mail) => {
             console.log(num,mail)
			dispatch({ "type": "MI_PERFIL_SET_DATOS_OTP", numero: num, correo: mail});
        }
    }
}

class AutorizacionModificacion extends React.Component {

   
    componentDidMount = () => {
     
        let $this = this;
        authentication.onAuthStateChanged(function(user) {
            if (user) {
                let redux = angular.element(document.querySelector('ui-view')).scope().$parent.state.redux;
                
                redux.dispatch({ "type": "CVE_CLIENTE_UNICO", "uid": authentication.currentUser.uid });
                conectarFirebase(redux);
                $this.props.cargarPreguntas();
            }
        });
    }
    
    render() {

      
        return <div className="card" id="modal-autorizacion-modificacion-movil"> 
                
                { this.props.muestraCodigoV == false && 
                <AutorizacionModificacionMovilModal />
                }       
                { (this.props.paso !== 0) && 
                    <ModalCambiarContrasena />
                }
            </div>;
    }
}export default connect (mapState, mapDispatch)(AutorizacionModificacion);


// WEBPACK FOOTER //
// ./src/movil/mi-perfil/autorizacionModificacion.cmpt.js